<div style="margin-left: 10px;" data-cy="io-detail-container">
  <dx-data-grid [dataSource]="docs" keyExpr="DocumentID"
                [hoverStateEnabled]="true" [height]="'100%'"
                [selectedRowKeys]="[]" [showRowLines]="true"
                (onRowDblClick)="onDblClick.emit($event.data)"
                (onContextMenuPreparing)="onDataGridRightClick($event)" data-cy="io-detail-grid">

    <dxo-selection mode="multiple" data-cy="io-detail-selection"></dxo-selection>
    <dxo-scrolling mode="infinite" data-cy="io-detail-scrolling"></dxo-scrolling>
    <dxo-paging [enabled]="false" data-cy="io-detail-paging"></dxo-paging>

    <dxi-column dataField="DocumentFileName" dataType="string" [allowResizing]="true"
                [allowFiltering]="false" [allowSorting]="false"
                caption="File Name" data-cy="io-detail-filename-column">
    </dxi-column>

    <dxi-column dataField="Description" [allowResizing]="true"
                caption="Description" [customizeText]="descriptionColumn_customizeText"
                [allowFiltering]="false" [allowSorting]="false" data-cy="io-detail-description-column">
    </dxi-column>

    <dxi-column dataField="DocumentCreateDate" dataType="datetime" [allowResizing]="true"
                [allowFiltering]="false" [allowSorting]="false"
                caption="Created" data-cy="io-detail-created-column">
    </dxi-column>

    <dxi-column dataField="DocumentModifiedDate" dataType="datetime" [allowResizing]="true"
                [allowFiltering]="false" [allowSorting]="false"
                caption="Modified" data-cy="io-detail-modified-column">
    </dxi-column>

    <dxi-column [allowFiltering]="false" [allowSorting]="false" [allowResizing]="true"
                dataField="dataDocumentTags" caption="Categories"
                [customizeText]="categoriesColumn_customizeText" data-cy="io-detail-categories-column">
    </dxi-column>

  </dx-data-grid>
</div>
